<template>
  <div class="row">

    <div class="col-md-12">

      <div class="row">

        <div class="col-md-12 d-flex">

          <div class="card card-table flex-fill">
            <!-- Example split danger button -->

            <div class="card-body">

              <div class="table-responsive">
                <div style="margin:5px;" class="row filter-row" v-if="selectedTable.length">
                  <div class="col-sm-6 col-md-3">
                    <div class="form-group">
                      <button :disabled="isLoadingBtn" @click.prevent="actionDelete" class="btn btn-danger btn-block">
                        <i class="la la-trash"></i> Remove
                      </button>
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-3">
                    <div class="form-group">
                      <button @click.prevent="actionNotFollowup" :disabled="isLoadingBtn"
                        class="btn btn-secondary btn-block">
                        <i class="la la-stop"></i> Not Followup
                      </button>
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-3">
                    <div class="form-group">
                      <button :disabled="isLoadingBtn" @click.prevent="actionFollowup"
                        class="btn btn-success btn-block">
                        <i class="la la-book"></i> Follow Up
                      </button>
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-3">
                    <div class="text-right">
                      <!-- <button class="btn btn-success btn-block">Scrape</button>-->
                      <a @click.prevent="hideActions" class="btn btn-xs">
                        <i class="fa fa-close"></i> Close
                      </a>
                    </div>
                  </div>
                  <p>
                  <ul style="">
                    <li><b>Remove</b>, data ringkasan akan dihapus.</li>
                    <li><b>Follow Up</b>, menandakan data tersebut sudah anda tindak lanjuti.</li>
                    <li><b>Not Follow Up</b>, menandakan data tersebut belum anda tindak lanjuti.</li>

                  </ul>
                  </p>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="btn-group" style="margin:5px;">
                      <button class="btn btn-primary btn-sm dropdown-toggle" type="button" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">
                        Tambah AI Chat
                      </button>
                      <div class="dropdown-menu">
                        <router-link class="dropdown-item" :to="'/automation/welcome-chat/list'">Welcome
                          Chat</router-link>
                        <router-link class="dropdown-item" :to="'/automation/working-chat/list'">Working
                          Chat</router-link>
                        <router-link class="dropdown-item" :to="'/automation/away-chat/list'">Away Chat</router-link>
                      </div>
                      <button style="margin-left:10px;" :disabled="isLoading" @click.prevent="listSummaryExcel"
                        class="btn btn-sm btn-primary">
                        <i class="fa fa-download"></i> Excel
                      </button>
                    </div>

                  </div>
                </div>
                <div class="row">

                  <div class="col-md-12">
                    <div v-if="linkDownload != ''" class="alert alert-success">Data berhasil dibuat, silakan klik <a
                        :href="linkDownload" target="_blank">link</a> berikut jika download otomatis tidak berfungsi. <a
                        class="text-danger" @click="closeMessageLinkDownload"><i class="fa fa-remove"></i></a></div>

                    <table class="table table-hover custom-table mb-0">

                      <thead>

                        <tr>

                          <th rowspan="2">

                            <div class="checkbox">

                              <label>

                                <input type="checkbox" v-model="selectAllTable" />

                              </label>

                            </div>

                          </th>

                          <th class="text-center" rowspan="2">Tgl. Dibuat</th>
                          <th class="text-center">Kode</th>


                          <th class="text-center" rowspan="2">Lisensi</th>

                          <th class="text-center">No. Pelanggan</th>



                          <th rowspan="2" class="text-center">Rangkuman Percakapan</th>
                          <th colspan="3" class="text-center">Saran Follow Up</th>
                          <th class="text-center">Status</th>
                          <th rowspan="2" class="text-center">Tgl Diubah</th>

                        </tr>
                        <tr>
                          <th><input @change="searchData" v-model="serverParams.columnFilters.summary_code" type="text"
                              class="form-control" placeholder=""></th>
                          <th><input @change="searchData" v-model="serverParams.columnFilters.message_number"
                              type="text" class="form-control" placeholder=""></th>

                          <th class="text-center">Alasan Perlu/Tidak Ditindaklanjuti</th>
                          <th class="text-center">Pesan Untuk Pelanggan</th>
                          <th class="text-center">Waktu Terbaik</th>
                          <th>
                            <select v-model="paramStatus" @change="actionFilterStatus" class="form-control">
                              <option value="">Select Status</option>
                              <option v-bind:value="'not_followup'">Not Follow Up</option>
                              <option v-bind:value="'followup'">Follow Up</option>
                            </select>
                          </th>
                        </tr>
                      </thead>

                      <tbody v-if="isLoading">

                        <tr>

                          <td>

                            <Skeleton :count="1" />

                          </td>

                          <td>

                            <Skeleton :count="1" />

                          </td>

                          <td>

                            <Skeleton :count="1" />

                          </td>

                          <td>

                            <Skeleton :count="1" />

                          </td>

                          <td>

                            <Skeleton :count="1" />

                          </td>

                          <td>

                            <Skeleton :count="1" />

                          </td>

                          <td>

                            <Skeleton :count="1" />

                          </td>
                          <td>

                            <Skeleton :count="1" />

                          </td>
                          <td>

                            <Skeleton :count="1" />

                          </td>
                          <td>

                            <Skeleton :count="1" />

                          </td>
                        </tr>

                      </tbody>

                      <tbody v-else>

                        <template v-if="rows.length">

                          <tr v-for="(row, idx) in rows" :key="idx">

                            <td>

                              <div class="checkbox">

                                <label>

                                  <!-- <input type="checkbox" name="checkbox" /> -->

                                  <input type="checkbox" v-model="selectedTable" :value="row" />

                                </label>

                              </div>

                            </td>

                            <td class="text-wrap">

                              {{ formatLocalDateWithDay(row.create_datetime) }}

                            </td>
                            <td class="text-wrap">

                              {{ row.summary_code }}

                            </td>
                            <td>{{ row.license_phone_number }} </td>

                            <td>

                              <a :href="'https://wa.me/' + row.message_number" target="_blank"> {{ row.message_number }}

                              </a>

                            </td>



                            <td class="text-wrap">
                              <ul style="list-style:none;">
                                <read-more :text="row.ai_user_summary" :limit="50" />
                              </ul>
                            </td>
                            <td class="text-wrap">
                              {{ row.follow_up_reason }}

                            </td>
                            <td class="text-wrap">
                              {{ row.suggested_message }}


                            </td>
                            <td class="text-wrap">
                              <div v-if="row.follow_up_days != '0'">
                                {{ row.follow_up_days }} hari setelah rangkuman dibuat.
                                <hr />
                              </div>
                              <div class="text-center">
                                <div class="btn-group btn-block">
                                  <button class="btn   btn-primary dropdown-toggle" type="button" data-toggle="dropdown"
                                    aria-haspopup="true" aria-expanded="false">
                                    Aksi
                                  </button>
                                  <div class="dropdown-menu">
                                    <button :disabled="isLoadingBtn" @click.prevent="actionRegenerateSuggest(row.id,row.create_datetime)"
                                      class=" dropdown-item btn " type="button">
                                      <i class="fa fa-refresh"></i> Minta Saran Lain
                                    </button>
                                    <button :disabled="isLoadingBtn" @click.prevent="actionCreateSchedule(row.id)"
                                      v-if="row.suggested_message != '' && row.has_follow_up == '0'"
                                      class=" dropdown-item btn " type="button">
                                      <i class="fa fa-bullhorn"></i> Jadwalkan Pengiriman
                                    </button>
                                    <a :href="'https://wa.me/' + row.message_number + '?text=' + row.suggested_message"
                                      target="_blank" v-if="row.suggested_message != ''" class=" dropdown-item btn "
                                      type="button">
                                      <i class="fa fa-whatsapp"></i> Kirim Sekarang
                                    </a>

                                  </div>
                                </div>
                              </div>

                            </td>
                            <td>
                              <div v-if="row.is_followup == '0'" class="badge badge-info">Not Follow Up</div>
                              <div class="badge badge-success" v-else>Follow Up

                                <div>
                                  {{ formatLocalDateWithDay(row.has_follow_up_datetime) }}

                                </div>
                              </div>

                            </td>
                            <td class="text-wrap">
                              <span v-if="row.update_datetime != '0'">
                                {{ formatLocalDateWithDay(row.update_datetime) }}
                              </span>
                            </td>
                          </tr>
                        </template>
                        <template v-else>
                          <tr>

                            <td colspan="7" class="text-center">

                              <div class="text-center text-muted">

                                Data saat ini belum tersedia.

                                <br />

                                <br />

                              </div>



                            </td>

                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <span class="footer__row-count__label">Displaying</span>
          <select @change="onPerPageChange(serverParams.perPage)" autocomplete="off" name="perPageSelect"
            v-model="serverParams.perPage" style="width: 100px;" class="select-to-paginasi">
            <option value="5">5 / page</option>
            <option value="10">10 / page</option>
            <option value="20">20 / page</option>
            <option value="30">30 / page</option>
            <option value="40">40 / page</option>
            <option value="50">50 / page</option>
          </select>
          <span class="footer__row-count__label">of {{ totalRecords }} total records</span>
        </div>
        <div class="col-sm-12 col-md-6 text-right" v-if="serverParams.perPage < totalRecords">
          <a href="javascript:void(0)" @click="onPrevChange(parseInt(currentPage))" tabindex="0" class="btn"
            :class="{ disabled: parseInt(currentPage) - 1 <= 0 }">
            <span class="chevron left"></span>
            <span>Prev</span>
          </a>
          page
          <input style="width:100px;" min="1" type="number" v-model="currentPage"
            @keyup.enter="onPageChange(parseInt(currentPage))" class />
          of {{ Math.ceil(totalRecords / serverParams.perPage) }}
          <a href="javascript:void(0)" @click="onNextChange(parseInt(currentPage))" tabindex="0"
            class="footer__navigation__page-btn" :class="'btn ' + {
              disabled:
                parseInt(currentPage) + 1 >
                Math.ceil(totalRecords / serverParams.perPage)
            }">
            <span>Next</span>
            <span class="chevron right"></span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import ReadMore from './ReadMore.vue';

import {
  currentDateTimeUnix,
  formatLocalDateWithDay,
  timeAgo,
} from "@/utils/helper";
export default {
  components: {
    Skeleton,
    ReadMore
  },
  data() {
    return {
      linkDownload: '',
      selectedTable: [],
      baseUrl: process.env.VUE_APP_BASE_URL,
      rows: [],
      totalRecords: 0,
      currentPage: 1,
      rowPage: 1,
      isLoadingBtn: false,
      isLoading: false,
      paramStatus: '',
      serverParams: {
        columnFilters: {
          summary_code: "",
          message_number: "",
          is_followup: "",
          start_date: "",
          start_date: ""
        },
        page: 1,
        perPage: 5 // perPage
      }
    };
    //  isactive : true
  },
  computed: {
    selectAllTable: {
      get: function () {
        return this.rows
          ? this.selectedTable.length == this.rows.length
          : false;
      },
      set: function (value) {
        var selectedTable = [];

        if (value) {
          this.rows.forEach(function (row) {
            // selectedTable.push(row.id);
            selectedTable.push(row);
          });
        }

        this.selectedTable = selectedTable;
      }
    }
  },
  async created() {
    // console.log("list sessions")
    this.loadItems();
    this.currentPage = this.serverParams.page;

  },
  methods: {
    actionCreateSchedule(id) {

      this.isLoadingBtn = true;
      this.$fire({
        title:
          "Apakah anda yakin untuk membuat pesan terjadwal dari data ini?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      })
        .then(async r => {
          if (r.value == true) {
            let newParam = {
              summary_id: parseInt(id)
            };
            this.$store
              .dispatch("aiKey/createSchedule", newParam)
              .then(response => {
                var { data } = response

                this.$fire({
                  title: "Success",
                  text: "Data berhasil dibuat",
                  type: "success",
                  timer: 2000
                });
                this.isLoadingBtn = false;
                this.selectedTable = [];
                this.selectAllTable = false;

                this.searchData();
                console.log("dataa:res", data, response)
                this.$router.push({
                  path: '/message_report/broadcast/info',
                  query: { id: data.broadcast_id }
                });

              })
              .catch(e => {
                this.isLoadingBtn = false;
              });
          } else {
            this.isLoadingBtn = false;
          }
        })
        .catch(e => {
          this.isLoadingBtn = false;
        });
    },
    actionRegenerateSuggest(id,summaryCode) {

      this.isLoadingBtn = true;
      this.$fire({
        title:
          "Apakah anda yakin untuk meminta saran baru untuk percakapan ini?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      })
        .then(async r => {
          if (r.value == true) {
            let newParam = {
              summary_id: parseInt(id)
            };
            this.$store
              .dispatch("aiKey/regenerateSuggest", newParam)
              .then(response => {
                this.$fire({
                  title: "Success",
                  text: "Saran telah disesuaikan",
                  type: "success",
                  timer: 2000
                });
                this.isLoadingBtn = false;
                this.selectedTable = [];
                this.selectAllTable = false;

                this.serverParams.columnFilters.summary_code=summaryCode
                this.searchData();

              })
              .catch(e => {
                this.isLoadingBtn = false;
              });
          } else {
            this.isLoadingBtn = false;
          }
        })
        .catch(e => {
          this.isLoadingBtn = false;
        });
    },
    closeMessageLinkDownload() {
      this.linkDownload = '';
    },
    listSummaryExcel() {
      this.isLoading = true;
      this.$store
        .dispatch("aiKey/listSummaryExcel", this.serverParams)
        .then(response => {
          this.isLoading = false;
          this.linkDownload = response.data;
          if (this.linkDownload != '') {
            window.open(this.linkDownload, '_blank').focus();
          }
        })
        .catch(e => {
          this.isLoading = false;
        });
    },
    actionFilterStatus() {
      // console.log("paramstat: ",this.paramStatus)
      switch (this.paramStatus) {
        case 'not_followup':
          this.serverParams.columnFilters.is_followup = 0
          break;
        case 'followup':
          this.serverParams.columnFilters.is_followup = 1
          break;
        default:
          this.serverParams.columnFilters.is_followup = ''
          break;
      }
      this.searchData()
    },
    actionNotFollowup() {
      if (this.selectedTable.length == 0) {
        this.$fire({
          title: "Error",
          text: "Please select at least one data",
          type: "error",
          timer: 2000
        });
        return;
      }
      this.isLoadingBtn = true;
      this.$fire({
        title:
          "Apakah anda yakin untuk mengubah menjadi Not Followup " +
          this.selectedTable.length +
          " data?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      })
        .then(async r => {
          if (r.value == true) {
            let newParam = {
              id: this.selectedTable,
              is_followup: "0"
            };
            this.$store
              .dispatch("aiKey/summaryFollowup", newParam)
              .then(response => {
                this.$fire({
                  title: "Success",
                  text: "Data berhasil diperbaharui",
                  type: "success",
                  timer: 2000
                });
                this.isLoadingBtn = false;
                this.selectedTable = [];
                this.selectAllTable = false;

                this.searchData();
              })
              .catch(e => {
                this.isLoadingBtn = false;
              });
          } else {
            this.isLoadingBtn = false;
          }
        })
        .catch(e => {
          this.isLoadingBtn = false;
        });
    },
    actionDelete() {
      if (this.selectedTable.length == 0) {
        this.$fire({
          title: "Error",
          text: "Please select at least one data",
          type: "error",
          timer: 2000
        });
        return;
      }
      this.isLoadingBtn = true;
      this.$fire({
        title:
          "Apakah anda yakin untuk menghapus " +
          this.selectedTable.length +
          " data?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      })
        .then(async r => {
          if (r.value == true) {
            let newParam = {
              id: this.selectedTable
            };
            this.$store
              .dispatch("aiKey/summaryDelete", newParam)
              .then(response => {
                this.$fire({
                  title: "Success",
                  text: "Sesi telah dihapus",
                  type: "success",
                  timer: 2000
                });
                this.isLoadingBtn = false;
                this.selectedTable = [];
                this.selectAllTable = false;

                this.searchData();
              })
              .catch(e => {
                this.isLoadingBtn = false;
              });
          } else {
            this.isLoadingBtn = false;
          }
        })
        .catch(e => {
          this.isLoadingBtn = false;
        });
    },
    actionFollowup() {
      if (this.selectedTable.length == 0) {
        this.$fire({
          title: "Error",
          text: "Please select at least one data",
          type: "error",
          timer: 2000
        });
        return;
      }
      this.isLoadingBtn = true;
      this.$fire({
        title:
          "Apakah anda yakin untuk mengubah Follow Up " +
          this.selectedTable.length +
          " data?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      })
        .then(async r => {
          if (r.value == true) {
            let newParam = {
              id: this.selectedTable,
              is_followup: "1"
            };
            this.$store
              .dispatch("aiKey/summaryFollowup", newParam)
              .then(response => {
                this.$fire({
                  title: "Success",
                  text: "Data berhasil diperbaharui",
                  type: "success",
                  timer: 2000
                });
                this.isLoadingBtn = false;
                this.selectedTable = [];
                this.selectAllTable = false;

                this.searchData();
              })
              .catch(e => {
                this.isLoadingBtn = false;
              });
          } else {
            this.isLoadingBtn = false;
          }
        })
        .catch(e => {
          this.isLoadingBtn = false;
        });
    },
    hideActions() {
      this.selectAllTable = false;
      this.selectedTable = [];
    },
    substringTitle(bc_title) {
      let limit = 40;
      if (bc_title.lenght > limit) {
        return bc_title.substring(0, limit) + "..."
      }
      return bc_title

    },
    timeAgo(utcDatetime) {
      return timeAgo(utcDatetime);
    },
    formatHourFromUnix(utcdttz) {
      return formatHourFromUnix(utcdttz);
    },
    currentDateTimeUnix() {
      return currentDateTimeUnix();
    },
    formatLocalDateWithDay(value) {
      return formatLocalDateWithDay(value);
    },
    updateParams(newProps) {
      // console.log("newprops", newProps);
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    async onPageChange(page) {
      await this.updateParams({ page: page });
      this.currentPage = page;
      await this.loadItems();
    },
    async onNextChange(page) {
      if (
        page + 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page + 1 });
        this.currentPage = page + 1;
        await this.loadItems();
      }
    },
    async onPrevChange(page) {
      // console.log("this.currentPage:: ", this.currentPage);
      if (this.currentPage == 1) {
        return;
      }
      if (
        page - 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page - 1 });
        this.currentPage = page - 1;
        await this.loadItems();
      }
    },
    async onPerPageChange(params) {
      await this.updateParams({
        page: this.currentPage,
        perPage: this.serverParams.perPage
      });
      await this.loadItems();
    },
    async searchData() {
      // this.currentPage = await 1;
      // this.serverParams.columnFilters.page = await 1;
      // await this.getListData();

      this.currentPage = 1;
      this.rows = await [];
      this.loading = await true;
      this.totalRecords = await 0;
      var params = await { page: this.currentPage };
      await this.updateParams(params);
      await this.loadItems();
      this.loading = await false;
    },
    async loadItems() {

      this.isLoading = await true;
      this.serverParams.page =
        this.serverParams.page - 1 <= 0 ?
          await 0 :
          await ((this.serverParams.page - 1) * this.serverParams.perPage);

      await this.$store
        .dispatch("aiKey/listSummary", this.serverParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.totalRecords = data.totalRecords;
          this.rowPage = data.page;
          this.rows = data.data;
          this.isLoading = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },

  mounted() { },
  name: "aiListSummary"
};
</script>


// WEBPACK FOOTER //
// src/views/settings/components/AiListSummary.vue